import styled from 'styled-components';
import { Box, Typography, ButtonBase } from '@mui/material';

export const Description = styled(Typography).attrs({
  variant: 'h6',
  fontFamily: 'Mukta',
  fontWeight: 400,
  color: 'text.secondary',
})``;

export const ModalContainer = styled(Box).attrs({
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Button = styled(ButtonBase).attrs({
  variant: 'contained',
  sx: { mt: 3, mb: 2, fontWeight: 700, fontSize: 16, px: 4, py: 1, borderRadius: 1 },
})`
  background: ${({ theme }) => theme.gradients.primary};
  font-family: 'Mukta';
  color: white;
`;
